import React from 'react';
import { Settings } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#f8f9fa] border-t border-[#1a3d1f]/10 py-12 px-4 text-center text-gray-700" data-id="element-45">
      <div className="max-w-xl mx-auto flex flex-col items-center" data-id="element-46">
        <Settings className="w-8 h-8 text-[#84cc16] mb-4" data-id="element-47" />
        <p className="mb-2 text-gray-600" data-id="element-48">
          ¿Tenés alguna duda o problema con tu compra?
        </p>
        <a href="mailto:EbookDreamShop@gmail.com" className="text-[#84cc16] font-bold hover:underline text-lg" data-id="element-49">
          EbookDreamShop@gmail.com
        </a>
        <p className="mt-8 text-sm text-gray-400" data-id="element-50">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}